import 'react-datepicker/dist/react-datepicker.css';
import { Box, FormControl, Input, Textarea, FormLabel, FormHelperText } from '@chakra-ui/react';
import { FaCalendarAlt } from 'react-icons/fa';

// Assets
import { formatDate, parseDateBirthday } from 'services/Utils';

const EditField = ({ 
  id, 
  label, 
  type = 'text', 
  value, 
  editMode,
  isActive,
  isValid, 
  onChange, 
  placeholder = '',
  mt,
  mb,
  display,
  ...restProps
}) => {
  return (
    <FormControl variant={editMode ? placeholder ? 'none' : 'floating' : 'calm'} id={id} mt={mt} mb={mb} display={display}>
      {type === 'textarea' ? (
        <Textarea
          value={value}
          resize="none"
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          h={{ base: '226.5px !important' }}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      ) : (
        <Input
          value={type === 'datetime-local' ? formatDate(value) : type === 'date' ? parseDateBirthday(value) : value}
          type={type}
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          className={isValid ? 'input-valid' : 'input-invalid'}
          {...restProps}
        />
      )}
      <FormLabel
        htmlFor={id}
        display={placeholder ? 'none' : 'block'}
        className={isValid ? 'input-valid' : 'input-invalid'}
      >
        {label}
      </FormLabel>
      <FormHelperText
        className={isValid ? 'hidden' : 'input-error'}
      >
        Input invalid
      </FormHelperText>

    </FormControl>
  );
};

export default EditField;